// Single source of truth for "does this order need tickets?"
// ticketed values come from several forms with inconsistent casing:
//   new SO page: 'NO' | 'UPFRONT-NO-TICKETS' | 'YES FACTORY' | 'YES-LA' | 'YES-CHINA/LA'
//   PO edit form: 'No' | 'Yes-LA' | 'Yes-China' | 'Yes-LA/China' | 'Yes-Bangladesh'
const NO_TICKETS_VALUES = ['', 'NO', 'UPFRONT-NO-TICKETS']

const needsTickets = (ticketed) => {
  return !NO_TICKETS_VALUES.includes(String(ticketed == null ? '' : ticketed).trim().toUpperCase())
}

// the two forms spell the same choice differently — collapse to one short label
const TICKET_LABELS = {
  'YES FACTORY': 'Factory',
  'YES-FACTORY': 'Factory',
  'YES-LA': 'LA',
  'YES-CHINA': 'China',
  'YES-CHINA/LA': 'LA/China',
  'YES-LA/CHINA': 'LA/China',
  'YES-BANGLADESH': 'Bangladesh'
}

const ticketLabel = (ticketed) => {
  let key = String(ticketed == null ? '' : ticketed).trim().toUpperCase()
  return TICKET_LABELS[key] || key.replace(/^YES[- ]?/, '') || 'Tickets'
}

export {needsTickets, ticketLabel}
